jQuery(document).ready(function(jQuery) {
  
  jQuery(".join-now").click(function(){
    jQuery("#product-addtocart-button").click();
  });

  
 

  jQuery('.cart-sidebar-close, .overlay').on('click', function (e) {
    jQuery('#cart-sidebar').removeClass('active');
    jQuery('.overlay').removeClass("active");
  });


  jQuery('.buy-now-button').on('click',function(e){
    var form = jQuery(this).closest('form');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function(cart) { 
        klaviyo(cart);
        window.location.href = '/checkout';
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();
        
      
      }
    });
    e.preventDefault();
    
  });
  
  
  jQuery('.__product-cart-button').on('click',function(e){
    cart_sidebar_open();
    var form = jQuery(this).closest('form');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function(cart) { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();
        
      
      }
    });
    e.preventDefault();
    
  });

  jQuery('.subscribe-save-cart').on('click',function(e){
    cart_sidebar_open();
    var product_id = jQuery(this).attr('data-main-product-id');
    var vault_id = jQuery(this).attr('data-vault-product-id');
    var vault_plan_id = jQuery(this).attr('data-vault-plan-id');

    let formData = {
     'items':[
        {
          'id': product_id,
          'quantity': 1
        },
        {
          'id': vault_id,
          'selling_plan': vault_plan_id,
          'quantity': 1
        }
     ]
    };


    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      cart_sidebar_update();
      return response.json();
    })
    .catch((error) => {
      cart_sidebar_update();
      console.error('Error:', error);
    });

    


    

     e.preventDefault();
    
  });



  
  
  function cart_sidebar_open() {
    //console.log('cart_sidebar_open');
    jQuery('#cart-sidebar').addClass("active");
    jQuery('#cart-sidebar').addClass("_loading");
    jQuery('.overlay').addClass("active");
  };
  
  function cart_sidebar_update(){
      jQuery.getJSON('/cart.js', function(cart){
      //console.log(cart);
      cart_sidebar_update_mini_cart(cart);
      cart_sidebar_update_free_shipping(cart);
      cart_sidebar_update_product(cart);
      cart_sidebar_update_totals(cart);
      klaviyo(cart);
      jQuery('#cart-sidebar').removeClass("_loading");
      jQuery('#cart-sidebar').removeClass("is_empty");
        
        if (cart.item_count == 0) {
          jQuery('#cart-sidebar').addClass("is_empty");
        }
              
    });
  };
  
  function cart_sidebar_update_mini_cart(cart) {
    jQuery('.mini-cart .cart-count').html('('+cart.item_count+')');
  }
  function cart_sidebar_update_free_shipping(cart) {
    if(window.is_vault!=true){
      if (cart.item_count > 0) {
        for(var i = 0; i < cart.items.length; i++) {
          if(cart.items[i].id == vault_id) {
             is_vault = true;
          } 

        }
      }
    }
    
    if(is_vault == true) {
      var free_shipping_price = parseInt(window.free_shipping_price_vault );
      var free_shipping_qualified = window.free_shipping_vault_text;
     
    } else {
      var free_shipping_price = parseInt(window.free_shipping_price);
      var free_shipping_qualified = window.free_shipping_text;
    }
    
    
    
    
    var free_shipping_away = 0;
    var cart_total_price =  parseInt(cart.total_price) / 100;
    var free_shipping_bar = Math.round((cart_total_price * 100)/free_shipping_price);
    if (cart_total_price >= free_shipping_price) {
      jQuery('.ajax-cart-free-shipping .progress-bar').css('width', '100%');
      jQuery('.ajax-cart-free-shipping h3').text(free_shipping_qualified);
    } else {
      free_shipping_away = parseInt(free_shipping_price - cart_total_price);
      jQuery('.ajax-cart-free-shipping h3').html("$<span>"+free_shipping_away.toFixed(2)+"</span> Away from free shipping");
      //jQuery('.ajax-cart-free-shipping h3 span').text(free_shipping_away);
      jQuery('.ajax-cart-free-shipping .progress-bar').css('width', free_shipping_bar+'%');
    }
  }
  
  function cart_sidebar_update_product(cart) {
    jQuery('.cart-sidebar-products h5 span').text(cart.item_count);
    var template = '<li class="__cart_sidebar_item __cart_sidebar_{ID}" data-id="{ID}"><div class="cart-sidebar-product-image"><a href="{URL}"><img src="{IMAGE}" alt="Loading" loading="lazy" width="55"/></a></div><div class="cart-sidebar-product-details"><a href="{URL}">{NAME}</a><span><span>{OLD_PRICE}</span> {PRICE}</span>{DISCOUNT}{OPTION}<div class="__product-qty"><span class="qty_minus">-</span><input type="number" name="quantity" class="cart_sidebar_qty" data-id="{ID}" data-max="{MAX}" value="{QUANTITY}"/><span class="qty_plus">+</span></div></div><div class="cart-sidebar-product-remove" data-id="{ID}"><i class="fa-solid fa-trash-can"></i></div></li>';
    var ProductList = jQuery('.cart-sidebar-products ul');
    if (cart.item_count > 0) {
      var vault_hide = false;
      for(var i = 0; i < cart.items.length; i++) {
        
       
        if(cart.items[i].id == window.vault_id) {
           var vault_hide = true;
           
        } 


        var _price = cart.items[i].original_price;
        var discounted_price = cart.items[i].discounted_price;

        if(_price != discounted_price){
          var price=Shopify.formatMoney(cart.items[i].discounted_price);
          var old_price=Shopify.formatMoney(cart.items[i].original_price);
          var discount_title=cart.items[i].discounts[0]['title'];

        
          if(discount_title == 'VAULT 10% Discount'){
            var vault_hide = true;
          }
          
          var discount_html = '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg> '+discount_title+' </li></ul>';
        } else {
          var old_price='';
          var price=Shopify.formatMoney(cart.items[i].original_price);
          var discount_html= '';
          
        }


        var option_html = '';
        if(cart.items[i].options_with_values){
          for(var p = 0; p < cart.items[i].options_with_values.length; p++) {
               if(cart.items[i].options_with_values[p].value!="Default Title"){
                 option_html = '<p class="product-option">'+cart.items[i].options_with_values[p].name+': '+cart.items[i].options_with_values[p].value+'</p>';
               }
          }
        }
        
        
        if (i == 0) {
          ProductList.html('');
        }
        var item = template;
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{NAME\}/g, cart.items[i].product_title);  
        item = item.replace(/\{OPTION\}/g, option_html);
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || '');
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, cart.items[i].image);
        item = item.replace(/\{OLD_PRICE\}/g, old_price);
        item = item.replace(/\{PRICE\}/g, price);
        item = item.replace(/\{DISCOUNT\}/g, discount_html);
        item = item.replace(/\{MAX\}/g, 24);
        ProductList.append(item);

      }
      
      
       if(vault_hide == true){
          jQuery('.cart-sidebar-totals').hide();
        } else {
          jQuery('.cart-sidebar-totals').show();
          jQuery('#vault-checkbox').prop('checked', false);
        }

    } else {
      ProductList.html('');
      jQuery('#cart-sidebar').addClass("is_empty");
    }
    
  
  }
  function cart_sidebar_update_totals(cart) {
   vault_saving = Math.round(cart.total_price * (10 / 100));
   jQuery('.cws-vault-instant-saving span').html(Shopify.formatMoney(vault_saving));
   jQuery('.non-vault-sub-total span').html(Shopify.formatMoney(cart.total_price));
   jQuery('.cws-vault-vault-price span').html(Shopify.formatMoney(cart.total_price-vault_saving));
   jQuery('.cart-sidebar-footer span').html(Shopify.formatMoney(cart.total_price));
  }
  
  function cart_sidebar_update_quantity(product_id,quantity){
    cart_sidebar_open();
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity='+quantity+'&id='+product_id,
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
	    jQuery('.cart-sidebar-error-message').show();
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        cart_sidebar_update();
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();

      }
    });
  }

  function klaviyo(cart) { 
    __klaviyo(cart);
  };
  
  
  jQuery(document).delegate(".cart_sidebar_qty", "change", function(e) {
    var product_id = jQuery(this).attr('data-id');
    var quantity = jQuery(this).val();
    cart_sidebar_update_quantity(product_id,quantity);
   
  });
  
  
  jQuery(document).delegate(".__product-qty .qty_plus", "click", function(e) {
      var old_val = jQuery(this).parent().find("input").val();
      var max_val = jQuery(this).parent().find("input").attr('data-max');
      var product_id = jQuery(this).parent().find("input").attr('data-id');
      if ( parseFloat(old_val) >= 1 && parseFloat(old_val) < max_val) {
        var new_val = parseFloat(old_val) + 1;
        jQuery(this).parent().find("input").val(new_val);
        var quantity = new_val;
        cart_sidebar_update_quantity(product_id,quantity);
      }
  });
  
  
  jQuery(document).delegate(".__product-qty .qty_minus", "click", function(e) {
      var old_val = jQuery(this).parent().find("input").val();
      var product_id = jQuery(this).parent().find("input").attr('data-id');
      if ( parseFloat(old_val) > 0) {
        var new_val = parseFloat(old_val) - 1;
        jQuery(this).parent().find("input").val(new_val);
        var quantity = new_val;
        cart_sidebar_update_quantity(product_id,quantity);
      }
  });
  
  
  
   jQuery(document).delegate(".cart-sidebar-product-remove", "click", function(e) {
    cart_sidebar_open();
    var product_id = jQuery(this).attr('data-id');
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + product_id,
      dataType: 'json',
      success: function() { 
        cart_sidebar_update();
      },
      error: function(xhr, text) {
        jQuery('.cart-sidebar-error-message').text(jQuery.parseJSON(xhr.responseText).description);
        jQuery('#cart-sidebar .cart-sidebar-loading').hide();    
      }
    });
    
    e.preventDefault();
    
  });
  
  
  
  jQuery("#vault-checkbox").click(function(){
    jQuery(".vault-add").click();
  });
  
  
  jQuery(".variant-id").change(function(){
    var __option = jQuery(this).find('option:selected');
    jQuery(".product-pricing .product-price span").text(__option.attr("data-price"));
  });

    jQuery(document).delegate(".lqr-video-wrap img", "click", function(e) {
   
        var url = jQuery(this).attr('videoUrl');
        var id = jQuery(this).attr('videoId');
        var html = "";
        jQuery('#tiktokVideoModal .modal-body').html("<blockquote class='tiktok-embed'> <iframe name='"+id+"' src='"+url+"' style='width: 100%; height: 620px; display: block; visibility: unset; max-height: 620px;'></iframe> </blockquote>");
        jQuery('#tiktokVideoModal').modal('show');
    });
    jQuery('#closemyModal').on('click', function(){
        jQuery('#tiktokVideoModal').modal('hide');
        jQuery('#tiktokVideoModal .modal-body').html("");
    });


   jQuery('[data-toggle="tooltip"]').tooltip();
   document.addEventListener('rebuy.add', function () { 
       cart_sidebar_update();
       cart_sidebar_open();
   });

  jQuery(document).delegate(".___notify_me", "click", function(e) {
      jQuery('.__notify-me').click();
  })


  
  jQuery(document).delegate(".__notify-me", "click", function(e) {
    if(jQuery(this).data("title")!="undefined" && jQuery(this).data("product-id")!="undefined" && jQuery(this).data("variant-id")!="undefined"){
      jQuery('#notify-modal h3').text(jQuery(this).data("title"));
      jQuery('#notify-modal #product').val(jQuery(this).data("product-id"));
      jQuery('#notify-modal #variant').val(jQuery(this).data("variant-id"));
      jQuery('#notify-modal').modal('show');
    }
      
  });

  jQuery(document).delegate("#notify-modal .btn-close", "click", function(e) {
   jQuery('#notify-modal').modal('hide');
  });
  function validateEmail($email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test( $email );
    }


    jQuery(document).delegate("#notify-me-submit", "click", function (e) {
       var email_input = jQuery('#notify-modal input[id="email"]').val();
       var product_input = jQuery('#notify-modal input[id="product"]').val();
       var variant_input = jQuery('#notify-modal input[id="variant"]').val();
       e.preventDefault();

      if(email_input=='undefined' || email_input==''){
        jQuery('#notify-modal .error').show();
        return;
      }
      if(!validateEmail(email_input)) { 
        jQuery('#notify-modal .error').show();
        return;
      }

     if(email_input!=='undefined' && product_input!=='undefined' && variant_input!=='undefined'){
        jQuery('#notify-modal .error').hide();
        jQuery('#notify-modal .__loading').show();

       const payload = {
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                  "data": {
                      "type": "profile",
                      "attributes": {
                          "email": email_input,
                      }
                  }
                },
                "channels": ["EMAIL"],
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": "$shopify:::$default:::"+variant_input
                  }
                 }
              }
            }
          }
          
          var requestOptions = {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "revision":"2023-12-15"
              },
              body: JSON.stringify(payload),
          };
          fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=Ws7XCx",requestOptions)
              .then(response => {
                if (!response.ok) {
                    jQuery('#notify-modal .__loading').hide();
                    jQuery('#notify-modal .error').show();
                    jQuery('#notify-modal .error').text("Something went wrong Please try again later!");
                    return;
                  } else {
                    jQuery('#notify-modal .__loading').hide();
                    jQuery('#notify-modal .notify-me-form').hide();
                    jQuery('#notify-modal .success').show();
                    return;
                  }
              })
              .catch(error => console.log('error', error));
      }
   });


  jQuery('.swatch-option').on('click', function(){
     var type = jQuery(this).data("type");
     var value = jQuery(this).data("value");
     jQuery(this).closest('.swatch-attribute-options').children('.swatch-option').removeClass('selected');
     jQuery(this).addClass('selected');
     jQuery(this).closest('.swatch-attribute').children('.swatch-attribute-selected-option').text(jQuery(this).children('label').text());
     
     if(type == 'hat'){
       if(value=='trucker'){
         jQuery(".option-1-black-1-white-camo").hide();
         jQuery(".option-1-black-1-grey").hide();
         jQuery(".option-1-white-1-white-camo").hide();
         jQuery(".option-1-white-1-grey").hide();
       } else if(value=='regular'){
         jQuery(".option-1-black-1-white-camo").show();
         jQuery(".option-1-black-1-grey").show();
         jQuery(".option-1-white-1-white-camo").show();
         jQuery(".option-1-white-1-grey").show();
       }
     }
      
   });

  jQuery('.lqr-item').on('click', function(e){
    e.preventDefault();
    // var price = jQuery(this).data("price");
    // var id = jQuery(this).data("id");
    // jQuery(this).toggleClass("_selected");

    
    // var checkbox = jQuery(".lqr-"+id);  
    // checkbox.prop("checked", !checkbox.prop("checked"));

    
    // var total = 0;
    // jQuery(".lqr-item._selected").each(function(e){
    //     //console.log(jQuery(this).data('price'));
    //     total = total + jQuery(this).data('price');
    // });

    // jQuery(".lqr-items-total span").text(Shopify.formatMoney(total));


    
  });


  


});                    